import { AdQRConfig } from './qr.config';
import { Injectable } from '@angular/core';

declare var QRious: any;

@Injectable()
export class QRService {
  /** å½åqrå®ä¾ */
  readonly qr: any;
  /** èæ¯ */
  background: string;
  /** èæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ */
  backgroundAlpha = 1.0;
  /** åæ¯ */
  foreground: string;
  /** åæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ */
  foregroundAlpha: number;
  /** è¯¯å·®æ ¡æ­£çº§å« */
  level: string;
  /** äºç»´ç è¾åºå¾çMIMEç±»å */
  mime: string;
  /** åè¾¹è·ï¼åä½ï¼pxï¼ */
  padding: number;
  /** å¤§å°ï¼åä½ï¼pxï¼ */
  size: number;
  /** å¼ */
  value: string;

  constructor(cog: AdQRConfig) {
    Object.assign(this, cog);
    this.qr = new QRious();
  }

  /**
   * çæäºç»´ç ï¼å¹¶è¿åBase64ç¼ç 
   *
   * @param [value] éæ°æå®å¼
   */
  refresh(value?: string | Object): string {
    this.qr.set(typeof value === 'object' ? value : {
      background: this.background,
      backgroundAlpha: this.backgroundAlpha,
      foreground: this.foreground,
      foregroundAlpha: this.foregroundAlpha,
      level: this.level,
      padding: this.padding,
      size: this.size,
      value: value || this.value,
    });
    return this.dataURL;
  }

  /**
   * è¿åå½åäºç»´ç Base64ç¼ç 
   */
  get dataURL(): string {
    return this.qr.toDataURL();
  }
}
